import { render } from "./ProjectCollection.vue?vue&type=template&id=f2b6a024"
import script from "./ProjectCollection.vue?vue&type=script&lang=js"
export * from "./ProjectCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__